import {
  MRT_GlobalFilterTextField,
  MaterialReactTable,
  type MRT_ColumnDef,
  useMaterialReactTable,
} from 'material-react-table';
import { Box, Button, lighten, Stack } from '@mui/material';
import { KeyboardArrowDown, RemoveRedEye } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import CurrencyFormat from '@/utils/CurrencyFormat';

type StudentData = {
  student: {
    id: string;
    nome: string;
  };
  total_payments: number;
  total_payments_expiring: number;
  total_payments_expired: number;
  medium_days_expire: number;
  total_paid_time: number;
  total_paid_after: number;
  financial_score: number;
  total_discount: number;
};

const columns: Array<MRT_ColumnDef<StudentData>> = [
  {
    accessorKey: 'student.nome',
    header: 'Aluno',
    sortDescFirst: true,
    enableMultiSort: true,
    minSize: 100,
    maxSize: 150,
    Cell: ({ renderedCellValue }) => (
      <div style={{ marginLeft: '5px' }}>{renderedCellValue}</div>
    ),
  },

  {
    accessorKey: 'discipline_best_average',
    header: 'Disciplina com maior média',
    Cell: ({ renderedCellValue }) => (
      // <div style={{ marginLeft: '20px' }}>{}</div>
      <Box
      sx={{
        backgroundColor: '#CEFACE',
        height: '60px',
        width: '80%',
        display: 'flex',
        paddingLeft: '10px',
        alignItems: 'center'
      }}
    >
     {renderedCellValue}
    </Box>
    ),
  },
  {
    accessorKey: 'discipline_worst_average',
    header: 'Disciplina com menor média',
    Cell: ({ renderedCellValue }) => (
      <Box
        sx={{
          backgroundColor: '#FCE4D4',
          height: '60px',
          width: '80%',
          display: 'flex',
          paddingLeft: '10px',
          alignItems: 'center',
          
        }}
      >
       {renderedCellValue}
      </Box>
    ),
  },
  {
    accessorKey: 'score_value',
    header: 'Score pedagógico',
    minSize: 100,
    maxSize: 150,
    Cell: ({ renderedCellValue }) => (
      <div style={{ marginLeft: '40px' }}>{renderedCellValue}</div>
    ),
  },
  {
    accessorKey: 'index_failure',
    header: 'Indice reprovação',
    minSize: 100,
    maxSize: 150,
    Cell: ({ renderedCellValue }) => (
      <div style={{ marginLeft: '40px' }}>{renderedCellValue}</div>
    ),
  },
  {
    accessorKey: 'is_active',
    header: 'Status',
    maxSize: 100,
    Cell: ({ renderedCellValue }) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          background: 'rgba(239, 239, 239, 1)',
          borderRadius: '32px',
          padding: '4px 8px',
          textAlign:'center',
          justifyContent: 'center',
          width: '100px',
        }}
      >
        <div
          style={{
            background: renderedCellValue ? 'rgba(15, 219, 98, 1)' : 'rgba(255, 0, 0, 1)', // Verde para ativo, vermelho para inativo
            borderRadius: '50%',
            width: '10px',
            height: '10px',
            marginRight: '5px',
            textAlign: 'center'
          }}
        ></div>
        <div>

        {renderedCellValue ? 'Ativo' : 'Inativo'}
        </div>

        <KeyboardArrowDown sx={{marginLeft: '5px'}}/>
      </div>
    ),
  },
  
];

type TableHeaderCustomProps = {
  data: StudentData[];
  toBack: string;
};

const TableHeaderCustomTermometroPedagogico = ({ data, toBack }: TableHeaderCustomProps) => {
  const navigate = useNavigate();
  const tableBasic = useMaterialReactTable({
    columns,
    data,
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enableRowActions: true,
    enableRowSelection: false,
    enableBottomToolbar: false,
    localization: {
      search: 'Pesquisar por nome do aluno',
      actions: 'Ações'
    },
    initialState: {
      showGlobalFilter: true,
    },
    paginationDisplayMode: 'default',
    enablePagination: false,
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      variant: 'outlined',
      size: 'small',
      fullWidth: true,          
      placeholder: 'Pesquisar por nome…',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30],
      shape: 'rounded',
      variant: 'outlined',
    },
    renderRowActions: ({ row }) => {
      const handleClick = () => {
        const id = row.original.student.id;
        const name = row.original.student.nome;
        navigate(toBack, { state: { id, name } });
      };

      return (
        <Stack alignItems={'center'}>
          <RemoveRedEye onClick={handleClick} />
        </Stack>
      );
    },
    muiTableHeadCellProps: () => ({
      sx: {
        backgroundColor: 'rgb(247, 247, 247)',
        color: 'black',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    muiTableBodyCellProps: () => ({
      sx: {
        backgroundColor: '#fff',
        color: 'rgba(128, 128, 128, 1)',
        fontWeight: 400,
        fontSize: '12px',
        paddingLeft: '12px',
        paddingRight: '20px',
        padding: '0',
      },
    }),
    renderTopToolbar: ({ table }) => (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={1}
      >
        {/* LEFT‑aligned, full width filter */}
        <Box flexGrow={6} mr={2}>
          <MRT_GlobalFilterTextField
            table={table}
            //@ts-ignore
            textFieldProps={{
              placeholder: 'Pesquisar por nome do aluno…',
              variant: 'outlined',
              size: 'small',
              fullWidth: true,
            }}
          />
        </Box>

        {/* if you have any right‑side buttons, put them here */}
        {/* <Button onClick={…}>My Action</Button> */}
      </Box>
    )
  });

  return (
    <>
      <MaterialReactTable table={tableBasic} />
    </>
  );
};

export default TableHeaderCustomTermometroPedagogico;
